import { render } from "./ChallengePII.vue?vue&type=template&id=0f8118c9"
import script from "./ChallengePII.vue?vue&type=script&lang=js"
export * from "./ChallengePII.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__